
import { defineComponent, PropType } from "vue";
import store from "@/store";
import AcademicPerformancesService from "@/api/AcademicBase/AcademicPerformancesService";
import type {
    IAcademicPerformancesModel
} from "@/interfaces/modules";


export default defineComponent({
    name: "AcademicPerformancesTab",
    props: {
        competencyId: {
            type: Number as PropType<number>,
            required: true,
        },
    },
    data() {
        return {
            saving: false,
            form: {
                dialog: false,
                record: {} as IAcademicPerformancesModel,
            },
            table: {
                filters: { search: "" },
                currentPage: 1,
                loading: false,
                headers: [
                    { key: "DisplayCode", label: "Código", sortable: true },
                    { key: "Statement", label: "Enunciado", sortable: true },
                    { key: "WeightPercent", label: "Peso %", sortable: true },
                    { key: "Color", label: "Color", sortable: false },
                    { key: "CreatedByFormat", label: "Creación", sortable: true },
                    { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
                    { key: "action", label: "Acciones", sortable: false },
                ],
                records: [] as IAcademicPerformancesModel[],
                rowsPerPage: 10,
            } as any,
        };
    },
    async mounted() {
        await this.load();
    },
    watch: {
        competencyId: {
            immediate: false,
            async handler() {
                await this.load();
            },
        },
    },
    computed: {
        filteredItems(): any {
            const q = this.table.filters.search?.toLowerCase() || "";
            return q
                ? this.table.records.filter((item: IAcademicPerformancesModel) =>
                    [item.DisplayCode, item.Statement, item.Color, item.WeightPercent]
                        .filter(Boolean)
                        .some((v) => String(v).toLowerCase().includes(q))
                )
                : this.table.records;
        },
        rows(): number {
            return this.table.records?.length || 0;
        },
    },
    methods: {
        async load() {
            if (!this.competencyId) return;
            this.table.loading = true;
            try {
                // Ajusta al método real
                this.table.records = await AcademicPerformancesService.GetAcademicPerformancesByCompetencyId(this.competencyId as any) || [];
            } finally {
                this.table.loading = false;
            }
        },
        openModal() {
            this.form.record = {
                Id: 0,
                CompetencyId: this.competencyId,
                DisplayCode: "",
                WeightPercent: 0,
                Color: "",
                Statement: "",
            } as IAcademicPerformancesModel;
            this.form.dialog = true;
        },
        async edit(data: IAcademicPerformancesModel) {
            this.form.record = await AcademicPerformancesService.GetAcademicPerformancesById({
                Id: data.Id,
            } as any);
            this.form.dialog = true;
        },
        async handleSubmit(event: Event) {
            event.preventDefault();

            this.saving = true;

            try {
                await AcademicPerformancesService.PostAcademicPerformances(this.form.record);

                this.saving = false;
                this.form.dialog = false;

                store.dispatch("core/popupDialog", {
                    text: "Registro completado con éxito.",
                    type: "success",
                    showCancelButton: false,
                });

                await this.load();
            } catch (err: any) {
                this.form.dialog = false;
                this.saving = false;
                store.dispatch("core/popupDialog", {
                    text: `Error: ${err?.response?.data?.message || err?.message}`,
                    type: "error",
                    showCancelButton: false,
                });
            }

        }
    },
});
